export const PRODUCT_TYPE_PERIOD = "period";
export const PRODUCT_TYPE_DATE = "date";
export const PRODUCT_TYPE_TIMESLOT = "timeslot";

export const PRODUCT_TYPE_PAID_VOUCHER = "paid_voucher";
export const PRODUCT_TYPE_VOUCHER = "voucher";

export default {
  PRODUCT_TYPE_PERIOD,
  PRODUCT_TYPE_DATE,
  PRODUCT_TYPE_TIMESLOT,
  PRODUCT_TYPE_PAID_VOUCHER,
  PRODUCT_TYPE_VOUCHER,
};
